import { useEffect, useRef } from 'react';
import { useGLTF } from '@react-three/drei';
import { AnimationMixer } from 'three';
import { useFrame } from '@react-three/fiber';

export default function Character({ actions, currentAction }) {
  const { scene, animations } = useGLTF('../models/wizard.glb');
  const mixer = useRef(null);
  const actionsRef = useRef({});

  useEffect(() => {
    if (scene && animations.length) {
      mixer.current = new AnimationMixer(scene);
      animations.forEach((clip) => {
        const action = mixer.current.clipAction(clip);
        actionsRef.current[clip.name] = action;
        if (actions) {
          actions[clip.name] = action; // Guardar acción en el objeto actions pasado como prop
        }
      });

      // Iniciar la primera animación (idle, por ejemplo)
      if (currentAction) {
        actionsRef.current[currentAction].play();
      }
    }
  }, [scene, animations, actions, currentAction]);

  useEffect(() => {
    if (currentAction && actionsRef.current[currentAction]) {
      actionsRef.current[currentAction].reset().fadeIn(0.5).play();
    }

    return () => {
      if (currentAction && actionsRef.current[currentAction]) {
        actionsRef.current[currentAction].fadeOut(0.5);
      }
    };
  }, [currentAction]);

  useFrame((_, delta) => {
    if (mixer.current) {
      mixer.current.update(delta);
    }
  });

  return (
    <>
      <primitive
        scale={0.5}
        position={[0, -0.7, 0]}
        rotation-y={Math.PI}
        object={scene}
      />
    </>
  );
}
